// wp-icons — AI & Tech (10)
import { createWpIcon } from './createIcon.js';

export const Bot = createWpIcon('Bot', [
  ['path', { d: 'M12 8V4H8', key: 'a' }],
  ['rect', { width: 16, height: 12, x: 4, y: 8, rx: 2, key: 'b' }],
  ['path', { d: 'M2 14h2', key: 'c' }],
  ['path', { d: 'M20 14h2', key: 'd' }],
  ['path', { d: 'M15 13v2', key: 'e' }],
  ['path', { d: 'M9 13v2', key: 'f' }],
]);
export const Brain = createWpIcon('Brain', [
  ['path', { d: 'M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 0 0 12 18z', key: 'a' }],
  ['path', { d: 'M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 0 1 12 18z', key: 'b' }],
]);
export const Sparkles = createWpIcon('Sparkles', [
  ['path', { d: 'M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z', key: 'a' }],
  ['path', { d: 'M20 3v4', key: 'b' }],
  ['path', { d: 'M22 5h-4', key: 'c' }],
  ['path', { d: 'M4 17v2', key: 'd' }],
  ['path', { d: 'M5 18H3', key: 'e' }],
]);
export const Cpu = createWpIcon('Cpu', [
  ['rect', { width: 16, height: 16, x: 4, y: 4, rx: 2, key: 'a' }],
  ['rect', { width: 6, height: 6, x: 9, y: 9, rx: 1, key: 'b' }],
  ['path', { d: 'M15 2v2', key: 'c' }],
  ['path', { d: 'M15 20v2', key: 'd' }],
  ['path', { d: 'M2 15h2', key: 'e' }],
  ['path', { d: 'M2 9h2', key: 'f' }],
  ['path', { d: 'M20 15h2', key: 'g' }],
  ['path', { d: 'M20 9h2', key: 'h' }],
  ['path', { d: 'M9 2v2', key: 'i' }],
  ['path', { d: 'M9 20v2', key: 'j' }],
]);
export const Database = createWpIcon('Database', [
  ['ellipse', { cx: 12, cy: 5, rx: 9, ry: 3, key: 'a' }],
  ['path', { d: 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5', key: 'b' }],
  ['path', { d: 'M3 12c0 1.66 4 3 9 3s9-1.34 9-3', key: 'c' }],
]);
export const Server = createWpIcon('Server', [
  ['rect', { width: 20, height: 8, x: 2, y: 2, rx: 2, ry: 2, key: 'a' }],
  ['rect', { width: 20, height: 8, x: 2, y: 14, rx: 2, ry: 2, key: 'b' }],
  ['line', { x1: 6, x2: 6.01, y1: 6, y2: 6, key: 'c' }],
  ['line', { x1: 6, x2: 6.01, y1: 18, y2: 18, key: 'd' }],
]);
export const Cookie = createWpIcon('Cookie', [
  ['path', { d: 'M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5', key: 'a' }],
  ['path', { d: 'M8.5 8.5v.01', key: 'b' }],
  ['path', { d: 'M16 15.5v.01', key: 'c' }],
  ['path', { d: 'M12 12v.01', key: 'd' }],
  ['path', { d: 'M11 17v.01', key: 'e' }],
  ['path', { d: 'M7 14v.01', key: 'f' }],
]);
export const FlaskConical = createWpIcon('FlaskConical', [
  ['path', { d: 'M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2', key: 'a' }],
  ['path', { d: 'M8.5 2h7', key: 'b' }],
  ['path', { d: 'M7 16h10', key: 'c' }],
]);
export const Activity = createWpIcon('Activity', [
  ['polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12', key: 'a' }],
]);
export const Palette = createWpIcon('Palette', [
  ['circle', { cx: 13.5, cy: 6.5, r: 0.5, fill: 'currentColor', key: 'a' }],
  ['circle', { cx: 17.5, cy: 10.5, r: 0.5, fill: 'currentColor', key: 'b' }],
  ['circle', { cx: 8.5, cy: 7.5, r: 0.5, fill: 'currentColor', key: 'c' }],
  ['circle', { cx: 6.5, cy: 12.5, r: 0.5, fill: 'currentColor', key: 'd' }],
  ['path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z', key: 'e' }],
]);
